import React from 'react';
import { Box, Typography, Stack, Divider } from '@mui/material';
import { CheckCircleRounded, LockOutlined } from '@mui/icons-material';

const AssessmentCompletionMessage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f7f8fa',
        p: 2,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 400,
          bgcolor: 'background.paper',
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
        }}
      >
        {/* ── Green top bar ── */}
        <Box sx={{ height: 4, bgcolor: 'success.main', width: '100%' }} />

        <Box sx={{ p: 4, textAlign: 'center' }}>

          {/* ── Icon ── */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: 1,
              bgcolor: '#E8F5E9',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 3,
            }}
          >
            <CheckCircleRounded sx={{ fontSize: 34, color: 'success.main' }} />
          </Box>

          {/* ── Heading ── */}
          <Typography variant="h6" fontWeight={700} gutterBottom>
            Assessment submitted
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            Your responses have been recorded. Your instructor will review your results shortly.
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* ── Close note ── */}
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.75}>
            <LockOutlined sx={{ fontSize: 14, color: 'text.disabled' }} />
            <Typography variant="caption" color="text.disabled">
              You can safely close this window
            </Typography>
          </Stack>

        </Box>
      </Box>
    </Box>
  );
};

export default AssessmentCompletionMessage;